<template>
  <div class="home qjc-clearfix qjc-relative">
		<!-- 左側模塊 -->
		<ul class="modules qjc-fl">
			<li @click="to('https://medin.medinhealth.com/pc/index.html?from=hkhc&language=t')" class="medin-serve-vip">
				健康大數據<span class="qjc-ftw-500">VIP</span>服務
			</li>
			<li @click="to('https://www.medinbd.com/')" class="HKHC">
				<span class="qjc-ftw-500">HKHC</span>大數據體檢
			</li>
			<li class="doctors-online">
				名醫在線—敬請期待
			</li>
			<li @click="$router.push('/HK/shop')" class="medin-shop">
				<span class="qjc-ftw-500">HKHC</span>健康商城
			</li>
		</ul>
		
		<!-- 右側內容 -->
		<div class="right qjc-fr">
			<div class="top qjc-flex">
				<!-- 天氣 -->
				<div class="weather qjc-flex">
					<img :src="weather.img?require('@/assets/images/' + weather.img + '.png'):''" alt="天氣狀況圖">
					<dl>
						<dd class="qjc-fts-26">{{ weather.city }}</dd>
						<dt class="qjc-fts-36">{{ weather.temperature }}°C</dt>
						<dd class="qjc-fts-26">{{ weather.text }}</dd>
					</dl>
				</div>
				<!-- 日期 -->
				<dl class="date qjc-texta-r">
					<dt>{{ time }}</dt>
					<dd><span class="qjc-ftw-500">{{ date }}</span> {{ week }}</dd>
				</dl>
			</div>
			
			<swipe class="opers" :loop="false" indicator-color="#5FD6FF" :autoplay="5000">
				<swipe-item>
					<img @click="to('https://www.medinbd.com/')" class="case" src="../../../assets/images/to_medinbd.png" alt="香港体检">
				</swipe-item>
				<!-- 案例展示 -->
				<swipe-item>
					<img @click="to('https://yx.medinbd.com/#/case/pc')" class="case" src="../../../assets/images/hkhc_case.png" alt="案例展示">
				</swipe-item>
			</swipe>
			
			<!-- 健康頻道 -->
			<div class="health">
				<h3 class="qjc-ftw-n qjc-fts-32">
					健康頻道
					<a href="https://www.medinbd.com/article.html?language=t" class="more qjc-fts-24 qjc-fr">查看更多</a>
				</h3>
				
				<swipe @change="checkTab" :autoplay="5000" :show-indicators="false" ref="swipe">
					<swipe-item v-for="(list,index) in healthList" :key="index">
						<ul v-for="item in list" :key="item.id" class="list qjc-fts-30">
							<li @click="to(item.id?'https://www.medinbd.com/article/'+ item.id +'.html?language=t':item.url)">{{ item.title }}</li>
						</ul>
					</swipe-item>
				</swipe>
				
				<ol class="tabs qjc-flex">
					<li @click="tabClick(index)" v-for="(i,index) in healthList" :key="'tab'+index" :class="{ 'active': index == healthListPage }"></li>
				</ol>
			</div>
			
		</div>
		
		<create-code language="HK"></create-code>
		
  </div>
</template>

<script>
	// 引入vant Swipe
	import Swipe from 'vant/lib/swipe';
	import 'vant/lib/swipe/style';
	import SwipeItem from 'vant/lib/swipe-item';
	import 'vant/lib/swipe-item/style';
	//默認只能移動端事件，引入桌面端
	import '@vant/touch-emulator';
	
	import { getWeatherInfo, getHealth } from '@/utils/axios'
	
	import createCode from '@/components/createCode'
	
export default{
	name: 'HKhome',
	data() {
		return {
			weather: {
				img: '',
				text: '--',
				temperature: '--',
				city: '--'
			},//天氣狀況
			
			date: '--',
			time: '--',
			week: '--',
			
			healthList: [
				{ title: '新店曝光|把更好的月子服務，帶到您身邊', url: 'https://mp.weixin.qq.com/s/YyrXinQIEaS6r1Q0WB-Rwg' },
				{ title: '【新店開業】番禺店除甲醛現場曝光，不放過任何死角！', url: 'https://mp.weixin.qq.com/s/KTLeEAWZJNKmc1ZnOT_hJg' },
				{ title: '感謝信|來自媽媽們的「表白」', url: 'https://mp.weixin.qq.com/s/EaNQYSrhbQF6-dhaNIbg6A' },
				{ title: '熱烈祝賀安儒月子中心當選廣東省家政服務標準化技術委員會委員', url: 'https://mp.weixin.qq.com/s/WQGSGYJJxc0mjPGY4DDmSQ' },
				{ title: '產後康復除了關注身體更要關注心理', url: 'https://mp.weixin.qq.com/s/ZJpuzqZlCB6LB4V2f4kwiQ' }
			],// 默認寫死文章
			healthListPage: 0,
			
			
		}
	},
	components: {
		Swipe,
		SwipeItem,
		createCode
	},
	mounted() {
		this.$nextTick(() => {
			this.getWeather();
			this.getTime();
			
			this.getHealthList();
			
		})
	},
	methods: {
		// 获取天气信息 参数：调用api下标
		getWeather(apiListIndex) {
			var getWeatherTime = localStorage.getItem('getWeatherTime'),
				differ = new Date().getTime() - (getWeatherTime?getWeatherTime:0);
			var res = '';
			if(differ > (30 * 60 * 1000)){
				var index = apiListIndex?apiListIndex:0;
				
				// 三条线路
				if(index < 3){
					getWeatherInfo(index).then(data => {
						console.log(data);
						res = data;
						if(res.wea_img){
							
							// 存储接口调取时间，存储数据，三十分钟后再次调取
							localStorage.setItem('getWeatherTime', new Date().getTime());
							localStorage.setItem('weatherInfo', JSON.stringify(res));
							
							this.showWeather(res);
						}else{
							this.getWeather(++index);
						}
						
					})
				}else{
					alert('天氣信息獲取失敗');
				}
				
			}else{
				res = JSON.parse(localStorage.getItem('weatherInfo'));
				if(res.wea_img){
					this.showWeather(res);
				}else{
					localStorage.removeItem('weatherInfo');
				}
			}
			
		},
		//展示天氣情況
		showWeather(res){
			// 天氣狀況
			this.weather.img = res.wea_img;
			this.weather.text = res.wea;// 描述
			this.weather.temperature = res.tem;// 實時氣溫
			this.weather.city = res.city
			
			// 日期
			// this.date = res.date.split('-').join('/');
			// this.week = res.week;
			
			// 隔三十分钟調取一次
			var that = this;
			setTimeout(() => {
				that.getWeather();
			}, 30 * 60 * 1000);
		},
		
		// 獲取健康頻列表
		getHealthList(){
			getHealth().then(res => {
				// console.log(res);
				
				if(res.status == 1){
					
					// 两條一頁
					var list = this.healthList.concat(res.data.data),
						forList = [];
					for(var i=0;i<list.length;i++){
						var last = forList[forList.length-1];
						if(last && last.length < 2){
							last.push(list[i]);
						}else{
							forList.push([list[i]]);
						}
					}
					this.healthList = forList;
					
				}else{
					alert(res.msg);
				}
			});
		},
		//指示器
		checkTab(index) {
			this.healthListPage = index;
		},
		// 指示器時間
		tabClick(index) {
			this.$refs.swipe.swipeTo(index);
		},
		
		// 獲取時間
		getTime() {
			// 接口無時間,獲取當前時間
			var now = new Date();
			this.time = (now.getHours()<10?'0'+now.getHours():now.getHours()) + ':' + (now.getMinutes()<10?'0'+now.getMinutes():now.getMinutes());
			
			// 時間校準(毫秒校準)
				var speed = (60 - now.getSeconds()) * 1000 - now.getMilliseconds();
			
			// 日期
			this.date = now.getFullYear() + '/' + (now.getMonth()+1) + '/' + now.getDate();
			var weeks = ['星期日','星期一','星期二','星期三','星期四','星期五','星期六'];
			this.week = weeks[now.getDay()];
			
			// 周期性一分鐘一次
			setTimeout(() => {
				this.getTime();
			}, speed);
			
		},
		
		// 跳轉連結
		to(url) {
			window.location.href = url;
		}
	}
}
</script>

<style scoped>
	.opers >>> .van-swipe__indicators{
		bottom: 0.12rem;
	}
	.opers >>> .van-swipe__indicator:not(:last-child){
		margin-right: 0.16rem;
	}
	.opers >>> .van-swipe__indicator{
		opacity: 1;
		background-color: #325D6C;
		transition: all .5s;
	}
	.opers >>> .van-swipe__indicator--active{
		width: 24px;
		border-radius: 0.12rem;
	}
</style>
<style lang="scss" scoped>
	.home{
		height: 9.9rem;
		padding: 0.6rem 0.8rem 0;
		background: url(https://meidn-image.oss-cn-beijing.aliyuncs.com/file/2020/home_bg.png) no-repeat;
		background-size: 100% 100%;
		font-weight: lighter;
		
		.modules{
			width: 11.87rem;
			
			li{
				float: left;
				width: 5.82rem;
				height: 4.08rem;
				font-size: 0.36rem;
				color: #E3ECFF;
				background-size: 100% 100%;
				background-repeat: no-repeat;
				margin-bottom: 0.25rem;
				padding-top: 3.32rem;
				text-align: center;
				
				&:nth-child(odd){
					margin-right: 0.23rem;
				}
				&.medin-serve-vip{
					background-image: url(../../../assets/images/medinserve_vip.png);
				}
				&.HKHC{
					background-image: url(../../../assets/images/HKHC.png);
				}
				&.doctors-online{
					background-image: url(../../../assets/images/doctors_online.png);
				}
				&.medin-shop{
					background-image: url(../../../assets/images/medin_shop.png);
				}
				
				&:active{
					opacity: .8;
				}
			}
		}
		
		.right{
			width: 5.48rem;
			color: #5FD6FF;
			
			&>div{
				background: linear-gradient(180deg,rgba(49,92,147,0.5) 0%,rgba(22,47,90,0.5) 100%);
			}
			
			.top{
				height: 1.8rem;
				justify-content: space-between;
				align-items: center;
				border-radius: 0.06rem;
				margin-bottom: 0.24rem;
				
				dt{
					font-weight: 400;
				}
				.weather{
					justify-content: flex-start;
					align-items: center;
					
					img{
						width: 1.54rem;
						height: auto;
					}
					dt{
						line-height: 0.54rem;
					}
					dd{
						line-height: 0.32rem;
					}
				}
				.date{
					padding-right: 0.24rem;
					
					dt{
						font-size: 0.72rem;
						line-height: 0.88rem;
					}
					dd{
						font-size: 0.21rem;
						line-height: 0.32rem;
					}
				}
			}
			
			.opers{
				margin-bottom: 0.24rem;
				
				.case{
					display: block;
					width: 100%;
					height: 1.8rem;
				}
			}
			
			.health{
				height: 4.33rem;
				border-radius: 0.08rem;
				
				h3{
					line-height: 0.32rem;
					padding: 0.24rem 0.32rem 0.15rem;
					font-weight: lighter;
					border-bottom: 0.01rem solid #3D5E90;
					
					.more{
						position: relative;
						color: #5FD6FF;
						margin-right: 0.16rem;
						
						&::after{
							position: absolute;
							content: '';
							top: 50%;
							right: -0.16rem;
							width: 0.16rem;
							height: 0.16rem;
							border-top: 0.01rem solid #5FD6FF;
							border-right: 0.01rem solid #5FD6FF;
							transform: translateY(-50%)rotateZ(45deg);
						}
					}
				}
				
				.list{
					li{
						position: relative;
						font-size: 0.3rem;
						height: 1.47rem;
						line-height: 0.5rem;
						padding: 0.28rem 0.32rem;
						overflow: hidden;
						
						&:active{
							background-color: #112948;
						}
						&::after{
							position: absolute;
							left: 0.32rem;
							right: 0.32rem;
							bottom: 0;
							content: '';
							border-bottom: 0.01rem dashed #3D5E90;
						}
					}
				}
				
				.tabs{
					height: 0.61rem;
					justify-content: center;
					align-items: center;
					
					li{
						width: 0.16rem;
						height: 0.16rem;
						background-color: #325D6C;
						border-radius: 0.02rem;
						margin: 0 0.12rem;
						
						&.active{
							background-color: #86D2ED;
						}
					}
				}
				
			}
			
		}
		
		
	}
</style>